<template>
    <div class="relative mt-half md:mt-full mx-auto w-52 sm:w-440px md:w-672px lg:w-928px">
        <button v-if="prevEnabled" type="button" @click.prevent="previous()" class="block absolute top-0 -translate-x-full left-0 w-auto h-full transform transition duration-300 ease-out hover:scale-90">
            <svg
                class="block w-7 mr-4"
                role="img"
                height="74"
                width="39"
                viewBox="0 0 39 74"
                aria-hidden="true"
                focusable="false"
            >
                <path
                    d="M38.414 1.645L3.06 37l35.355 35.355L37 73.77.23 37 37 .23z"
                    fill="#161715"
                    fill-rule="evenodd"
                />
                <span class="sr-only">&larr; Previous</span>
            </svg>
        </button>
        <flickity ref="flickity" class="w-full" :options="flickityOptions">
            <slot></slot>
        </flickity>
        <button v-if="nextEnabled" type="button" @click.prevent="next()" class="block absolute top-0 right-0 translate-x-full w-auto h-full transform transition duration-300 ease-out hover:scale-90">
            <svg
                class="block w-7 ml-4"
                role="img"
                height="74"
                width="39"
                viewBox="0 0 39 74"
                aria-hidden="true"
                focusable="false"
            >
                <path
                    d="M.586 1.645L35.94 37 .586 72.355 2 73.77 38.77 37 2 .23z"
                    fill="#161715"
                    fill-rule="evenodd"
                />
                <span class="sr-only">Next &rarr;</span>
            </svg>
        </button>
    </div>
</template>

<script>
import Flickity from 'vue-flickity';

// import imagesLoaded from 'vue-images-loaded';
export default {
    components: {
        Flickity
    },
    // directives: { imagesLoaded },
    props: {},

    data() {
        return {
            flickityOptions: {
                accessibility: true,
                prevNextButtons: false,
                pageDots: false,
                cellAlign: 'left',
                contain: true,
                groupCells: true // important to keep this to enable button showhide below
            },
            totalSlides: null,
            prevEnabled: false,
            nextEnabled: false
            // currentSlide: '01'
        };
    },

    methods: {
        next() {
            this.$refs.flickity.next();
        },

        previous() {
            this.$refs.flickity.previous();
        },

        onSlideChange(event, index) {
            this.checkButtonStatus();
        },
        checkButtonStatus() {
            const groupCount = this.$refs.flickity.$flickity.slides.length - 1;
            const selectedIndex = this.$refs.flickity.selectedIndex();
            this.nextEnabled = selectedIndex < groupCount;
            this.prevEnabled = selectedIndex > 0;
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.checkButtonStatus();
            this.$refs.flickity.on('change', this.onSlideChange);
        });

        // console.log (this.$refs.flickity.$flickity);
        // For reference
        // .flickity-viewport {
        //     transition: height 0.2s;
        // }
    }
};
</script>
